
import axios from 'axios'
import Qs from 'qs'
import wx from 'weixin-js-sdk';

import {getServer} from '@/utils/share'
import {setStore, getStore, removeStore,GAMPGL} from '@/config/mUtils'
import {APPID} from "@/service/getData";

import D from '@/wc-messagebox'
import Vue from 'vue'
Vue.use(D)

//export const routeUrl = "https://jpjstest.geeker.com.cn/";
export const routeUrl = "https://jpjs.geeker.com.cn/";

var isWxMini = false; //不是小程序环境

//判断是不是支付宝环境
export const isAlipayClient = () => {
  console.log(navigator.userAgent)
  if (navigator.userAgent.indexOf('AlipayClient') !== -1) {
    return true;
  }
  return false;
};

/**
 * 调用微信接口
 */
export const wxInitial = (callback) => {
  if (isAlipayClient()) return
  let isSuccess = false;
  var obj = { appid: APPID };
  obj.url = location.href.split('#')[0];

  try {
    if(isSuccess === false){
      axios.post( getServer().admin + "getsign.action", Qs.stringify(obj), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (data) {
        isSuccess = true;

        // 响应成功回调
        wx.config({
          debug: false,
          appId: obj.appid,
          timestamp: data.data.timestamp,
          nonceStr: 'Wm3WZYTPz0wzccnW',
          signature: data.data.sign,
          jsApiList: ["getLocation", "openLocation", "onMenuShareTimeline", "onMenuShareAppMessage","updateTimelineShareData","updateAppMessageShareData",
            "onMenuShareQQ", "onMenuShareQZone", "previewImage","playVoice","onVoicePlayEnd",
            "pauseVoice","stopVoice","chooseWXPay"]
        });

        if(callback) callback();

      })
    }
  } catch (e) {
    isSuccess = false;
  }

  wx.miniProgram.getEnv(function(res) {
    if(res.miniprogram){  //是小程序环境
      isWxMini = true;
    }else {  //是h5环境
      isWxMini = false;
    }
    console.log(isWxMini)
  });

};
wxInitial();

//判断是不是小程序环境
export const getWxMini = (callback) => {
  wx.miniProgram.getEnv(function(res) {
    if(res.miniprogram){  //是小程序环境
      if(callback) callback(true);
    }else {  //是h5环境
      if(callback) callback(false);
    }
  });
};

//判断是不是微信环境
export const isweixin = () => {
  const is_weixin = (function(){return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1})();
  if(is_weixin){
    return true;
  }else{
    return false;
  }
};

/**
 * 微信定位
 * @param callback  回调函数
 * @param return   返回经纬度信息
 */
export const wxGetPosition = (callback) => {
  if(!isweixin()){
    console.log('高德定位')
    GAMPGL('404573c508c5457fdc8040930e2efe6e').then(function (AMap) {
      //加载地图，调用浏览器定位服务
      var latlng = getStore("latlng")
      if(latlng && latlng.latitude && latlng.longitude){
        if(callback) callback(latlng);
        console.log(latlng);
      }else {
        var map = new AMap.Map('MAPCOM');
        map.plugin('AMap.Geolocation', function() {
          var geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,//是否使用高精度定位，默认:true
            timeout: 8000          //超过10秒后停止定位，默认：无穷大
          });
          //map.addControl(geolocation);
          geolocation.getCurrentPosition();
          AMap.event.addListener(geolocation, 'complete', onComplete);//返回定位信息
          AMap.event.addListener(geolocation, 'error', onError);      //返回定位出错信息
        });
      }

      //解析定位结果
      function onComplete(data) {
        var res = { latitude: data.position.lat, longitude: data.position.lng };
        setStore("latlng", res);
        console.log(res);
        if(callback) callback(res);
      }

      //解析定位错误信息
      function onError(data) {
        var res = { latitude: "", longitude: "" };
        if(callback) callback(res);
      }
    });

  }else {
    console.log('微信定位')
    let nn = false;
    wx.ready(function () {
      wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          if(callback) callback(res);
          nn = true;
        },
        fail: function (res){
          res = { latitude: "", longitude: "" };
          if(callback) callback(res);
          nn = true;
        }
      });
    })

    setTimeout(function(){
      if(nn == false){
        let res = { latitude: "", longitude: "" };
        if(callback) callback(res);
        nn = true;
      }
    },5000);
  }

};


/**
 * 微信定位成功后 返回城市编码信息
 * @param callback 回调函数 可返回当前用户所在经纬度
 */
export const getCityInfo = (callback) => {
  wxGetPosition(function(res){
    let obj ={ lat: res.latitude, lng: res.longitude };
    // let obj ={ lat: 30.658531511538364, lng: 104.06942972029641 };
    axios.post( getServer().admin + "getCityCode.do", Qs.stringify(obj), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(function (data) {
      if(data.data.errcode == "00000"){
        setStore("cityInfo",data.data.data);
      }else {
        let cityInfo = { citycode: "1", city: "全国", address: "" };
        setStore("cityInfo",cityInfo);
      }
      if(callback) callback(obj);
    })
  });
};


/**
 * 微信导航
 * @param callback 回调函数
 */
export const wxOpenMapLocation = (lat, lng, name, address) => {
  try {
    lat = parseFloat(lat);
    lng = parseFloat(lng);
    wx.openLocation({
      latitude: lat,    //23.099994,
      longitude: lng,     //113.324520,
      name: name,
      address: address,
      scale: 14
    });
  } catch (e) {
    window.location.href = " https://apis.map.qq.com/tools/routeplan/eword=" + name + "&epointx=" + lng + "&epointy=" + lat + "&navibutton=2?referer=myapp&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77";
  }
}


/**
 * 微信分享
 * @param title  标题
 * @param desc  分享信息
 * @param img   分享小图
 * @param link   产品链接
 * @param fn   回调函数
 */
export const wxShareme = (title,desc,img,link,fun) => {
  var imgs = img ==""?(routeUrl+"dist/static/logo.jpg"):img;
  wx.ready(function () {
    wx.onMenuShareTimeline({  //分享到朋友圈
      title: desc, // 分享标题
      link: routeUrl+"dist/index.html#" + link, // 分享链接
      imgUrl: imgs, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
        if(fun) fun()
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    wx.updateTimelineShareData({  //分享到朋友圈
      title: desc, // 分享标题
      link: routeUrl+"dist/index.html#" + link, // 分享链接
      imgUrl: imgs, // 分享图标
    });

    wx.onMenuShareAppMessage({ //分享给好友
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: routeUrl+"dist/index.html#" + link, // 分享链接
      imgUrl: imgs, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        // 用户确认分享后执行的回调函数
        if(fun) fun()
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    wx.updateAppMessageShareData({ //分享给好友
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: routeUrl+"dist/index.html#" + link, // 分享链接
      imgUrl: imgs, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    });
  })
};


/**
 * 微信图片预览
 * @param curSrc  当前图片
 * @param srcList  图片数组
 */
export const wxImgPreview = (curSrc, srcList) => {
  //这个检测是否参数为空
  if (!curSrc || !srcList || srcList.length == 0) {
    return;
  }
  wx.previewImage({
    current: curSrc, // 当前显示图片的http链接
    urls: srcList // 需要预览的图片http链接列表
  });

  //这个使用了微信浏览器提供的JsAPI 调用微信图片浏览器
  //WeixinJSBridge.invoke('imagePreview', {
  //  'current': curSrc,
  //  'urls': srcList
  //});
};

/**
 * 富文本图片点击预览
 * @param curSrc  当前图片
 * @param srcList  图片数组
 */
export const htmlImgPreview = (e) => {
  console.log(e, e.target);
  if(e.target.nodeName == 'IMG' || e.target.nodeName == 'img'){
    const img = e.target.currentSrc
    wxImgPreview(img,[img])
  }
};


/**
 * 调用微信支付
 */
export const handleWxpay = (self,options,callback) => {
  if(isweixin) {
    //options 是接口返回的wx的一些配置信息
    //wxReadyToPay(self,options,callback);
    wx.miniProgram.getEnv(function(res) {
      if(res.miniprogram){  //是小程序环境
        wxMiniPay(options)
      }else {  //是h5环境
        wxReadyToPay(self,options,callback);
      }
    });
  }else {
    self.$toast("请打开微信支付");
  }
};
//app链接h5 调用微信支付
export const handleWxpay1 = (self,options,callback,code) => {
  if(options.wx_url){

    var redirect_url  = encodeURIComponent(location.href);

    // 返回至指定页面
    var wx_url = options.wx_url + "&redirect_url=" + redirect_url;

    const iframe = document.createElement('iframe')
    iframe.style.display ='none'
    iframe.setAttribute('src', wx_url)
    iframe.setAttribute('sandbox','allow-top-navigation allow-scripts')
    document.body.appendChild(iframe)
  }
};


export const wxReadyToPay = (self,options,callback) => {
  if (typeof WeixinJSBridge == "undefined"){
    if( document.addEventListener ){
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady(self,options,callback), false);
    }else if (document.attachEvent){
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady(self,options,callback));
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady(self,options,callback));
    }
  }else{
    onBridgeReady(self,options,callback);
  }
};

export const onBridgeReady = (self,options,callback) => {
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    options,
    function(res){
      //使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
      switch(res.err_msg){
        case "get_brand_wcpay_request:ok": //支付成功
          self.$toast('支付成功')
          if(callback) callback(true)
          break;
        case "get_brand_wcpay_request:cancel": //支付取消
          self.$toast('取消支付')
          break;
        case "get_brand_wcpay_request:fail": //支付失败
          self.$toast('支付失败')
          break;
        default:
          self.$toast("支付失败");
          break;
      }
    }
  )
};


/**
 * 创建订单
 * @param self    指向this
 * @param bag   需要购买的订单专辑包
 * @param extral  返回给前端的订单需要的信息
 * @param callback   回调函数
 * @param isExtral   true:从弹窗点击，可以直接发起支付, 地图页面直接发起支付
 */
export const creatOrder = (self,bag,extral,callback,isExtral) => {
  self.$loading.show('提交订单中');

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let qid =  getStore("qid") || "";
  if(qid){
    qid = qid.qid
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }

  let isSuccess = false;
  if(isSuccess){
    return;
  }else {
    let userInfo = getStore("userInfo");
    let source =  getStore("source") || "";
    let openidMini = getStore("openidMini");
    let obj = {
      openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
      pid: bag.id,
      totalmoney: bag.price,
      cid: extral.cid || '',
      qid: qid,
      spotid: spotid,
      sourceBtn: source.source || ''
    };

    let payInfo = getStore("payInfo");
    let pay_info = (payInfo && payInfo.pay_info) || "";
    if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
      obj.index = 1;
    }

    axios.post( getServer().admin + "createorder.do", Qs.stringify(obj), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'appKey': appKey
      }
    }).then(function (data) {
      if(data.data.errcode == "00000"){

        if(data.data.extral && data.data.extral.money && isExtral !== true){  //如果有优惠券
          self.$loading.hide();
          isSuccess = true;
          self.bag = bag;
          self.extral = data.data.extral;
          self.couponid = data.data.extral.cid;
        }else {
          let obj1 = { index: 1 }; //公众号发起支付
          if(isWxMini){ obj1 = {};  }
          let url = data.data.data;
          if(pay_info==1){
            obj1 = {code: data.data.extral.code, index: 1 }; //公众号发起支付
            url = getServer().admin + 'wap/getOrderInfo.action'
          }

          axios.post( url, Qs.stringify(obj1), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'appKey': appKey
            }
          }).then(function (data) {
            self.$loading.hide();
            isSuccess = true;

            let param = data.data.data;
            if(param == 0){
              self.$toast('支付成功')
              if(callback) callback(true)
              return
            }else if (!param) {
              self.$toast("支付错误");
              return
            }else {
              //判断是否是在微信小程序环境
              param = JSON.parse(param)
              if(pay_info==1){
                self.orderCode = obj1.code
                handleWxpay1(self,param,callback,obj1.code)
              }else {
                handleWxpay(self,param,callback)
              }
            }
          })
        }
      }else {
        isSuccess = true;
        self.$loading.hide();
        self.$toast(data.data.errmsg);
      }

    }).catch(function (data){
      isSuccess = true;
      self.$loading.hide();
      self.$toast(data.data.errmsg);

      setTimeout(function(){
        if (data.data.errmsg == '已经购买') {
          if(callback) callback(true)
        }
      },500)
    })
  }

};


/**
 * 创建打赏订单
 * @param self    指向this
 * @param bag   需要购买的订单专辑包
 * @param extral  返回给前端的订单需要的信息
 * @param callback   回调函数
 */
export const creatDSOrder = (self,pid,price,callback) => {
  self.$loading.show('提交订单中');

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let qid =  getStore("qid") || "";
  if(qid){
    qid = qid.qid
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }

  let isSuccess = false;
  if(isSuccess){
    return;
  }else {
    let userInfo = getStore("userInfo");
    let openidMini = getStore("openidMini");
    console.log(isWxMini)
    console.log(openidMini )
    console.log(openidMini && openidMini.openid)
    let obj = {
      openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
      pid: pid,
      price: price,
      qid: qid,
      spotid: spotid,
      sourceBtn: 'weixin-ds'
    };
    let payInfo = getStore("payInfo");
    let pay_info = (payInfo && payInfo.pay_info) || "";
    if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
      obj.index = 1;
    }

    axios.post( getServer().admin + "/createorderDS.do ", Qs.stringify(obj), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'appKey': appKey
      }
    }).then(function (data) {

      if(data.data.errcode == "00000"){
        let obj1 = { index: 1 };
        if(isWxMini){ obj1 = {};  }
        let url = data.data.data;
        if(pay_info==1){
          obj1 = {code: data.data.extral.code, index: 1 }; //公众号发起支付
          url = getServer().admin +  'wap/getOrderInfo.action'
        }

        axios.post( url, Qs.stringify(obj1), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'appKey': appKey
          }
        }).then(function (data)  {
          self.$loading.hide();
          isSuccess = true;

          let param = data.data.data;
          if (!param) {
            self.$toast("支付错误");
            return
          }else {
            //判断是否是在微信小程序环境
            param = JSON.parse(param)
            if(pay_info==1){
              self.orderCode = obj1.code
              handleWxpay1(self,param,callback,obj1.code)
            }else {
              handleWxpay(self,param,callback)
            }
          }
        })
      }else {
        self.$loading.hide();
        self.$toast(data.data.errmsg);
      }

    }).catch(function (data){
      isSuccess = true;
      self.$loading.hide();
      self.$toast(data.data.errmsg);

    })
  }

};
/**
 * 创建打赏订单（支付宝支付）
 * @param {*} self 指向this
 * @param {*} pid 需要购买的订单专辑包
 * @param {*} price 返回给前端的订单需要的信息
 * @param {*} callback 回调函数
 * @returns
 */
export const creatDSZfbOrder = (self,pid,price,callback) => {
  self.$loading.show('提交订单中');

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let qid =  getStore("qid") || "";
  if(qid){
    qid = qid.qid
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }

  let isSuccess = false;
  if(isSuccess){
    return;
  }else {
    let userInfo = getStore("userInfo");
    let openidMini = getStore("openidMini");
    console.log(isWxMini)
    console.log(openidMini)
    console.log(openidMini && openidMini.openid)
    let obj = {
      openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
      pid: pid,
      price: price,
      qid: qid,
      spotid: spotid,
      sourceBtn: 'weixin-ds'
    };
    let payInfo = getStore("payInfo");
    let pay_info = (payInfo && payInfo.pay_info) || "";
    if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
      obj.index = 1;
    }

    axios.post( getServer().admin + "/alipay/v2/createorderDS.do ", Qs.stringify(obj), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'appKey': appKey
      }
    }).then(function (data) {

      if(data.data.errcode == "00000"){
        let obj1 = { index: 1 };
        if(isWxMini){ obj1 = {}; }
        // let url = data.data.data;
        let url = `${data.data.data}&url=${encodeURIComponent('https://jpjs.geeker.com.cn/dist/dist/dist/dist/index.html#/pay-success')}`
        if(pay_info==1){
          obj1 = {code: data.data.extral.code, index: 1 }; //公众号发起支付
          url = getServer().admin +  'wap/getOrderInfo.action'
        }

        axios.post( url, Qs.stringify(obj1), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'appKey': appKey
          }
        }).then(function (data) {
          self.$loading.hide();
          isSuccess = true;
          setStore('payUrl', {url: window.location.href}, 1)
          setStore('form', {data: data.data.data}, 1)
          window.location.href = 'https://jpjs.geeker.com.cn/dist/dist/dist/dist/index.html#/pay-transfer'
          // self.$loading.hide();
          // isSuccess = true;
          // setStore('payUrl', {url: window.location.href})
          // const div = document.createElement('div');
          // div.innerHTML = data.data.data;
          // document.body.appendChild(div);
          // document.forms[0].submit();
        })
      }else {
        self.$loading.hide();
        self.$toast(data.data.errmsg);
      }

    }).catch(function (data){
      isSuccess = true;
      self.$loading.hide();
      self.$toast(data.data.errmsg);

    })
  }
}

/**
 * 试听结束创建无订单记录的订单
 * @param self    指向this
 * @param index   当前试听音频的下标
 * @param bagList  点击试听当前所在语音列表
 */
export const listenEndOrder = (self,index,bagList,type) =>{
  let obj;
  if(type){
    obj = {
      openid: self.userInfo.openid,
      pid: bagList.id,
      totalmoney: bagList.price,
      cid: self.couponid || ''
    };
  }else {
    obj = {
      openid: self.userInfo.openid,
      pid: bagList[index].id,
      totalmoney: bagList[index].price,
      cid: self.couponid || ''
    };
  }

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }

  axios.post( getServer().admin + "createNoorder.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if(data.data.errcode == "00000"){
      if (data.data.extral.cid) {
        self.couponid = data.data.extral.cid;
      }
      self.extral = data.data.extral;
    }else {
      self.$toast(data.data.errmsg);

      if (data.data.errmsg == '已经购买') {
        if(type){
          self.res.isbuy = true;
        }else {
          setTimeout(function() {
            bagList[index].buy = 12;
            self.bag = {};

            pushOrder('dist/index.html#/video-play?id='+bagList[index].id+'&spotid='+bagList[index].spotid+'&shopid='+bagList[index].shopid + '&form=spot' + '&TimeStamp='+ self.TimeStamp+ '&appKey='+ appKey);
          }, 500)
        }
      }
    }
  })
};


/**
 * 试听播放点击事件
 * @param self    指向this
 * @param index   当前试听音频的下标
 * @param bagList  点击试听当前所在语音列表
 */
export const listenTurl = (self,index,bagList) =>{
  self.Audio = document.getElementById('Audio');
  self.global.set_glabalClear()

  if ((self.listType && self.listType == self.lastListType && self.currIndex == index) || (!self.listType && self.currIndex == index)){
    if (self.Audio.paused) {
      self.Audio.play();
      bagList[index].isplay = 1;
      self.$set(bagList, index, bagList[index]);
      TimeSpan(self,index,bagList[index].toaTime,bagList);
    } else {
      self.Audio.pause();
      self.$loading.hide();
      bagList[index].isplay = 0;
      self.$set(bagList, index, bagList[index]);
      if(self.videoTimer != null){
        clearInterval(self.videoTimer);
      }
    }
  }else {
    //self.Audio.play();
    if(self.listType && (self.listType != self.lastListType)){
      for(var i=0; i<self.bagList.length; i++){
        self.bagList[i].isplay = 0;
      }
      for(var i=0; i<self.tlist.length; i++){
        self.tlist[i].isplay = 0;
      }
    }else {
      for(var i=0; i<bagList.length; i++){
        bagList[i].isplay = 0;
      }
    }

    self.index1 = index;

    let appKey =  getStore("appKey") || "";
    if(appKey){
      appKey = appKey.appKey
    }

    let obj = {
      openid: self.userInfo.openid,
      vid: bagList[index].proid
    };
    axios.post( getServer().admin + "listen/usertry.do", Qs.stringify(obj), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'appKey': appKey
      }
    }).then(function (data) {
      if(data.data.errcode == '00000') {
        if(data.data.data.isTurl){
          self.Audio.play();
          setTimeout(function(){
            bagList[index].toaTime = data.data.data.time;
            bagList[index].resTime = data.data.data.time;
            self.currIndex = index;
            self.Audio.src = bagList[index].turl;
            self.Audio.preload = "auto";

            if(self.Audio.readyState != 4){
              self.$loading.show('音频加载中');
            }
            self.Audio.play();
            bagList[index].isplay = 1;
            self.$set(bagList, index, bagList[index]);
            TimeSpan(self,index,data.data.data.time,bagList);

            //记录收听历史接口
            axios.post( getServer().admin + "uploadHotLevel.do", Qs.stringify(obj), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'appKey': appKey
              }
            })

          },100)
        }else {
          self.currIndex = -1;
          self.Audio.pause();
          clearInterval(self.videoTimer);
          self.$toast(data.data.data.err);
          self.bag = bagList[index];
        }
      }else {
        self.$toast(data.data.errmsg)
      }
    })

  }
};


/**
 * 实时监听音频播放进度，播放结束弹出试听结束弹窗
 * @param self    指向this
 * @param index   当前试听音频的下标
 * @param totalTime  当前音频的试听时长
 * @param bagList  点击试听当前所在语音列表
 */
export const TimeSpan = (self,index,totalTime,bagList) =>{
  if(self.videoTimer != null){
    clearInterval(self.videoTimer);
  }
  self.videoTimer = setInterval(function () {
    if(self.Audio.currentTime > 0){
      self.$loading.hide();
    }
    if(self.Audio.currentTime >= totalTime){
      self.currIndex = -1;
      self.Audio.pause();

      bagList[index].isplay = 0;
      self.bag = bagList[index];
      clearInterval(self.videoTimer);
    }else {
      let rtime = parseInt((totalTime - self.Audio.currentTime) % 60);//获取剩余时间
      if(rtime != undefined && !isNaN(rtime)){
        rtime = rtime < 10 ? "0" + rtime : rtime;
        bagList[index].resTime = rtime;
        self.$set(bagList, index, bagList[index]);
      }
    }
    setStore("currVoice", {"currTime":self.Audio.currentTime,"currId":bagList[index].proid,"spotid":bagList[index].spotid},1);
  }, 1000);

  self.Audio.onended = function() {  //音频播放结束
    self.currIndex = -1;
    clearInterval(self.videoTimer);
    bagList[index].isplay = 0;
    self.bag = bagList[index];
  };
};


/**
 * 试听播放点击事件(专辑详情页面)
 * @param self    指向this
 * @param index  点击试听当前所在语音列表bagList下标
 */
export const listenTurlVideo = (self,index) =>{
  self.Audio = document.getElementById('Audio');
  self.global.set_glabalClear()

  if (self.currIndex == index) {
    if (self.Audio.paused) {
      self.Audio.play();
      self.isplay = 1;
      TimeSpanVideo(self,self.bagList[index].toaTime);
    } else {
      self.Audio.pause();
      self.$loading.hide();
      self.isplay = 0;
      if(self.videoTimer != null){
        clearInterval(self.videoTimer);
      }
    }
  } else {
    //self.Audio.play();
    self.isplay = 1;
    self.currTime = 0;
    self.index1 = index;

    let appKey =  getStore("appKey") || "";
    if(appKey){
      appKey = appKey.appKey
    }

    let obj = {
      openid: self.userInfo.openid,
      vid: self.bagList[index].id
    };
    axios.post( getServer().admin + "listen/usertry.do", Qs.stringify(obj), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'appKey': appKey
      }
    }).then(function (data) {
      if(data.data.errcode == '00000') {
        if(data.data.data.isTurl){
          self.Audio.play();
          setTimeout(function(){
            self.bagList[index].toaTime = data.data.data.time;
            self.currIndex = index;
            self.Audio.src = self.bagList[index].url;
            self.Audio.preload = "auto";
            if(self.Audio.readyState != 4){
              self.$loading.show('音频加载中');
            }
            self.Audio.play();
            self.isplay = 1;
            TimeSpanVideo(self,data.data.data.time);

            //记录收听历史接口
            axios.post( getServer().admin + "uploadHotLevel.do", Qs.stringify(obj), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'appKey': appKey
              }
            })

          },100)
        }else {
          self.currIndex = -1;
          self.Audio.pause();
          clearInterval(self.videoTimer);
          self.$toast(data.data.data.err);
          self.bag = self.bagInfo;
        }
      }else {
        self.$toast(data.data.errmsg)
      }
    })

  }
};


/**
 * 实时监听音频播放进度，播放结束弹出试听结束弹窗(专辑详情页面)
 * @param self    指向this
 * @param totalTime  当前音频的试听时长
 */
export const TimeSpanVideo = (self,totalTime) =>{
  if(self.videoTimer != null){
    clearInterval(self.videoTimer);
  }
  self.videoTimer = setInterval(function () {
    if(self.Audio.currentTime > 0){
      self.$loading.hide();
    }
    if(self.Audio.currentTime > totalTime){
      self.currIndex = -1;
      self.Audio.pause();

      self.isplay = 0;
      self.$toast('试听时间结束，请先购买');
      self.bag = self.bagInfo;
      clearInterval(self.videoTimer);
    }else {
      if(self.Audio.currentTime != undefined && !isNaN(self.Audio.currentTime)){
        self.currTime = self.Audio.currentTime;
      }
    }
    setStore("currVoice", {"currTime":self.Audio.currentTime,"currId":self.bagList[self.currIndex].id,"spotid":self.bagList[self.currIndex].spotid},1);
  }, 1000);

  self.Audio.onended = function() {  //音频播放结束
    self.currIndex = -1;
    clearInterval(self.videoTimer);
    self.isplay = 0;
    self.bag = self.bagInfo;
  };

};


/**
 * 播放音频点击事件(专辑详情页面)
 * @param self    指向this
 * @param index  点击试听当前所在语音列表bagList下标
 */
export const listenVideo = (self,index) =>{
  //self.Audio = document.getElementById('Audio');
  self.global.Audio1 = document.getElementById('Audio1');
  if (self.currIndex == index) {
    if (self.global.Audio1.paused) {
      self.global.Audio1.play();
      self.isplay = 1;
      TimeVideo(self,self.bagList[index].totaltime);

      self.global.set_playing(true)
      self.global.set_playerShow(true)

    } else {
      self.global.Audio1.pause();
      self.$loading.hide();
      self.isplay = 0;
      if(self.global.videoTimer != null){
        clearInterval(self.global.videoTimer);
      }

      self.global.set_playing(false)
      self.global.set_playerShow(false)
    }
  } else {
    self.isplay = 1;
    self.currTime = 0;
    self.index1 = index;

    let appKey =  getStore("appKey") || "";
    if(appKey){
      appKey = appKey.appKey
    }

    setTimeout(function(){
      self.currRewardShow = false;
      self.currIndex = index;
      self.global.Audio1.src = self.bagList[index].url;
      self.global.Audio1.preload = "auto";
      self.global.Audio1.playbackRate =  self.speedVideo;
      var currVoice = getStore("currVoice",1) || "";
      if(currVoice && currVoice.currTime > 0 && currVoice.currId == self.bagList[index].id){
        self.global.Audio1.currentTime = currVoice.currTime;
        setStore("currVoice", {"currTime":0,"currId":"","spotid":""},1);
      }
      self.global.Audio1.play();
      if(self.global.Audio1.readyState != 4){
        self.$loading.show('音频加载中');
      }
      self.isplay = 1;
      TimeVideo(self,self.bagList[index].totaltime);

      //记录收听历史接口
      let obj = {
        openid: self.userInfo.openid,
        vid: self.bagList[index].id
      };
      axios.post( getServer().admin + "uploadHotLevel.do", Qs.stringify(obj), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      });

      self.global.set_currBag(self.bagInfo)
      self.global.set_playing(true)
      self.global.set_playerShow(true)
      self.global.set_playList(self.bagList)
      self.global.set_currVoice(self.bagList[index])
      self.global.set_currIndex(index)
      self.global.set_currUrl(self.bagList[index].url)
      self.global.set_playSpeed(self.speedVideo);

    },100)
  }
};



export const listenVideoBySBY = (self,index) =>{
  self.global.Audio1 = document.getElementById('Audio1');
  self.currTime = 0;
  self.index1 = index;

    let appKey =  getStore("appKey") || "";
    if(appKey){
      appKey = appKey.appKey
    }

    setTimeout(function(){
      self.currRewardShow = false;
      self.currIndex = index;
      self.global.Audio1.src = self.bagList[index].url;
      self.global.Audio1.playbackRate =  self.speedVideo;
      var currVoice = getStore("currVoice",1) || "";
      if(currVoice && currVoice.currTime > 0 && currVoice.currId == self.bagList[index].id){
        self.global.Audio1.currentTime = currVoice.currTime;
        setStore("currVoice", {"currTime":0,"currId":"","spotid":""},1);
      }
      self.isplay = 0;

    },100)
};



/**
 * 实时监听音频播放进度，播放结束继续播放下一段音频(专辑详情页面)
 * @param self    指向this
 * @param totalTime  当前音频的总时长
 */
export const TimeVideo = (self,totalTime) =>{
  if(self.global.videoTimer != null){
    clearInterval(self.global.videoTimer);
  }
  self.global.videoTimer = setInterval(function () {
    if (self.global.Audio1.currentTime > 0) {
      self.$loading.hide();
    }
    if((self.$route.path=='/map'||self.$route.path=='/map-tour')&&(self.global.currBag.id==self.bagid || self.global.currBag.id==self.currGuide.id)){
      self.playSlider = document.getElementById('playSlider');
      if (self.global.Audio1.currentTime != undefined && !isNaN(self.global.Audio1.currentTime)) {
        self.currTime = (totalTime - self.global.Audio1.currentTime);
        if(self.buy == true){
          //self.currSlider = (self.global.Audio1.currentTime / totalTime) * self.playSlider.offsetWidth + "px";
        }
      }
    }else if((self.$route.path=='/video-play'||self.$route.path=='/video-play-lz'||self.$route.path=='/video-play-lz1'||self.$route.path=='/video-play-vr'||self.$route.path=='/video-play-sm'||self.$route.path=='/video-play-nx'||self.$route.path=='/video-play-py')&&self.global.currBag.id==self.id) {
      self.slider = document.getElementById('slider');
      if (self.global.Audio1.currentTime != undefined && !isNaN(self.global.Audio1.currentTime)) {
        self.currTime = self.global.Audio1.currentTime;
        if(self.id != '130'){
          self.currSlider = (self.global.Audio1.currentTime / totalTime) * self.slider.offsetWidth + "px";
          self.global.set_sliderWidth(self.slider.offsetWidth)
        }
        if(self.volmodal == 'show'&&self.previewShow == 1){
          console.log(self.index1,self.currTime)
        }
      }

      //没打赏过，没关闭打赏，免费专辑
      if (!self.res.isReward && self.res.noReward != 1 && self.bagInfo.price == 0) {
        //免费 试听20秒弹窗
        if (self.global.Audio1.currentTime >= 20 && self.currRewardShow == false) {
          self.rewardShow = 1;
          self.currRewardShow = true;
          if(self.res.noReward == 2){
            listenVideo(self,self.currIndex);
          }
        }
      }
    }else {
      clearInterval(self.global.videoTimer);
    }


  }, 1000);


  self.global.Audio1.onended = function() {  //音频播放结束
    if(self.$route.path=='/map'||self.$route.path=='/map-tour'){
      let currIndex = (self.currIndex == self.voicelist.length -1) ? 0 : (parseInt(self.currIndex) + 1);
      if(self.buy == true || currIndex< 2){
        playVideo(self,currIndex);


        if(self.$route.path=='/map-tour'){
          self.itemClick(self.voicelist[currIndex])
        }else {
          var ind = self.getIndex(self.spotlist,self.voicelist[currIndex].spotid,2);
          self.spotClick(ind);
        }

      }else {
        self.currIndex = -1;
        //self.Audio.pause();
        if(!self.global.Audio1.paused) self.global.Audio1.pause();
        self.isplay = 0;
        self.$toast('试听结束，请购买该张专辑');
        //clearInterval(self.playTimer);
        self.buyVideo();
        if(self.global.videoTimer != null){
          clearInterval(self.global.videoTimer);
        }
        self.global.set_playing(false)
        self.global.set_playerShow(false)
      }
    }else {
      let currIndex;
      if(self.$route.path=='/video-play'||self.$route.path=='/video-play-lz'||self.$route.path=='/video-play-lz1'||self.$route.path=='/video-play-vr'||self.$route.path=='/video-play-sm'||self.$route.path=='/video-play-nx'||self.$route.path=='/video-play-py'){
        if(self.volmodal == 'show'&&self.previewShow == 1){
          currIndex = self.currIndex;
        }else {
          currIndex = (self.currIndex == self.bagList.length -1) ? 0 : (parseInt(self.currIndex) + 1);
        }
      }else {
        currIndex = (self.global.currIndex == self.global.playList.length -1) ? 0 : (parseInt(self.global.currIndex) + 1);
      }
      if(self.id=='3064'||self.id=='3592'||self.id=='3591'||self.id =='3590'||self.id =='3598'){
        if((self.id=='3064'&&currIndex<40) || ((self.id=='3592'||self.id=='3591'||self.id =='3590'||self.id =='3598')&&currIndex>19) || self.res.isguide || self.res.isbuy){
          listenVideo(self,currIndex);

          if(self.mySwiper){
            self.mySwiper.slideTo(currIndex, 1000, false);
          }
        }else {
          self.$toast('试听时间结束，请先购买');
          self.bag = self.bagInfo;
          if(!self.global.Audio1.paused) self.global.Audio1.pause();
          self.isplay = 0;
          if(self.global.videoTimer != null){
            clearInterval(self.global.videoTimer);
          }
          self.global.set_playing(false)
          self.global.set_playerShow(false)
        }
      }else {
        if(self.previewShow == 1){
          console.log(currIndex)
          self.bagList[currIndex]['showpro'] = 1;
          self.previewData = self.bagList[currIndex];
          self.$set(self.previewData);
          self.$refs.alertPreviewImg.refreshInfo(self.previewData);
        }

        listenVideo(self,currIndex);


        if(self.mySwiper){
          self.mySwiper.slideTo(currIndex, 1000, false);
        }
      }
    }
  };

};


/**
 * 拖动播放进度按钮
 * @param self    指向this
 */
export const dragSlide = (self) => {
  if(self.global.videoTimer != null){
    clearInterval(self.global.videoTimer);
  }
  this.minDiv = document.getElementsByClassName("speedDot")[0]; //小方块
  this.width = parseInt(this.minDiv.offsetWidth); //小方块的宽度

  this.lineDiv = this.minDiv.parentNode; //背景长线条

  var that = this;
  var percent = 0;

  var move = function(e) {
    var x = e.touches[0].pageX;

    var lineDiv_left = that.getPosition(that.lineDiv).left; //长线条的横坐标
    var minDiv_left = x - lineDiv_left; //小方块相对于父元素（长线条）的left值
    if (minDiv_left < 0) {
      minDiv_left = 0;
    }

    //拖动指数
    percent = (minDiv_left / that.lineDiv.offsetWidth).toFixed(2);
    percent = percent > 1 ? 1 : percent;

    that.minDiv.style.left = percent*100 + "%";
    self.currSlider = percent*100 + "%";
  };

  var end = function() {
    self.currIndex = self.index1;

    if(self.id != self.global.currBag.id){
      self.global.Audio1.src = self.bagList[self.index1].url

      self.global.set_currBag(self.bagInfo)
      self.global.set_playList(self.bagList)
      self.global.set_currVoice(self.bagList[self.index1])
      self.global.set_currIndex(self.index1)
      self.global.set_currUrl(self.bagList[self.index1].url)
    }

    self.currTime = (self.bagList[self.index1].totaltime)*percent;
    self.isplay = 1;
    self.global.Audio1.play();
    if(self.global.Audio1.readyState == "4"){
      self.global.Audio1.currentTime = self.currTime;
    }else {
      self.currTime = 0;
      self.$loading.show('当前进度尚在缓冲中');
    }
    self.global.Audio1.play();
    self.global.set_playing(true)
    self.global.set_playerShow(true)

    TimeVideo(self,self.bagList[self.index1].totaltime);

  };

  //获取元素的绝对位置,工具函数
  this.getPosition = function(node) {
    var left = node.offsetLeft; //获取元素相对于其父元素的left值var left
    var top = node.offsetTop;
    var current = node.offsetParent; // 取得元素的offsetParent
    // 一直循环直到根元素

    while (current != null) {
      left += current.offsetLeft;
      top += current.offsetTop;
      current = current.offsetParent;
    }
    return {
      "left": left,
      "top": top
    };
  };
  this.minDiv.addEventListener("touchmove", move);
  this.minDiv.addEventListener("touchend", end);
};


/**
 * 上传图片
 * @param imgs    图片数组
 * @param callback    回调函数
 */
export const uploadPic = (imgs,callback) =>{
  let obj = { file: imgs.toString() };
  axios.post( getServer().admin + "uploadbase.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data);
  })
};

/**
 * 上传文件
 * @param imgs    图片数组
 * @param callback    回调函数
 */
export const uploadFile = (file, callback) => {
  axios.post(getServer().admin + "dao/upload.do", file, {
    headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .then(function (data) {
    if (callback) callback(data.data);
  });
};

/**
 * 上传图片
 * @param imgs    图片数组
 * @param callback    回调函数
 */
export const uploadCom = (bagid,info,score,imgs,callback) =>{
  let userInfo = getStore("userInfo");
  let obj = {
    openid: userInfo.openid,
    bagid: bagid,
    info: info,
    type: 0,
    score: score,
    img: imgs.toString(),
  };
  axios.post( getServer().admin + "comment.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data);
  })
};
//一图游上传评论
export const uploadComMap = (obj,callback) =>{
  axios.post( getServer().admin + "onemap/comment.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data);
  })
};

/**
 * 上传图片
 * @param imgs    图片数组
 * @param callback    回调函数
 */
export const uploadCard = (id ,imgs,message,callback) =>{
  let userInfo = getStore("userInfo");
  let obj = {
    id:id,
    openid: userInfo.openid,
    picture: imgs.toString(),
    message: message,
  };
  axios.post( getServer().admin + "plugin/sign.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data);
  })
};

/**
 * 国庆抢红包
 * @param activityid    活动id
 * @param callback    回调函数
 */
export const getCouponAtRandom = (activityid,callback) =>{
  let userInfo = getStore("userInfo");
  let obj = {
    openId: userInfo.openid,
    activityId: activityid,
    type: 0
  };
  axios.post( getServer().admin + "couponApi/getCouponAtRandom.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data);
  })
};

/**
 * 普通抢红包
 * @param activityid    活动id
 * @param type    活动id
 * @param callback    回调函数
 */
export const getCouponReceive = (activityid,type,callback) =>{
  let userInfo = getStore("userInfo");
  let obj = {
    openId: userInfo.openid,
    id: activityid,
    type: type
  };
  axios.post( getServer().admin + "couponApi/receive.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data);
  })
};

/**
 * 获取首页热门城市
 * @param sregion    省站点id
 * @param callback    回调函数
 */
export const getHotCity1 = (sregion,callback) =>{
  let obj = {
    sregion: sregion
  };
  axios.post( getServer().admin + "mini3/hotCity.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data.data);
  })
};

/**
 * 购买成功后，获取订单推送授权
 */
export const pushOrder = (url) =>{
  //window.location = getServer().admin + 'subscribeMsg.wap?callback='+ url ;
  if(isWxMini){
    window.location = routeUrl+url ;
  }else {
    window.location = routeUrl+'subscribeMsg.wap?callback='+ encodeURIComponent(url) ;
  }

};


/**
 * 支付页面获取产品信息
 * @param pid    产品id
 * @param cid    优惠券id
 * @param callback    回调函数
 */
export const getOrderProd = (pid, cid, callback) =>{
  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }

  let userInfo = getStore("userInfo");
  let obj = {
    openid: userInfo.openid,
    pid: pid,
    cid: cid
  };
  axios.post( getServer().admin + "ywtpay/calOrder.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if(callback) callback(data.data);
  })
};


/**
 * 创建订单（微信）
 * @param self    指向this
 * @param pid    专辑id
 * @param price   专辑价格
 * @param cid   优惠券id
 * @param callback   回调函数
 */
export const creatWxOrder = (self, pid, price, cid, callback) => {
  self.$loading.show('提交订单中');

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let qid =  getStore("qid") || "";
  if(qid){
    qid = qid.qid
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }

  let userInfo = getStore("userInfo");
  let source =  getStore("source") || "";
  let openidMini = getStore("openidMini");
  let obj = {
    openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
    pid: pid,
    totalmoney: price,
    cid: cid || '',
    qid: qid,
    spotid: spotid,
    sourceBtn: source.source || ''
  };

  let payInfo = getStore("payInfo");
  let pay_info = (payInfo && payInfo.pay_info) || "";
  if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
    obj.index = 1;
  }

  axios.post( getServer().admin + "createorder.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if(data.data.errcode == "00000"){

      let obj1 = { index: 1 }; //公众号发起支付
      if(isWxMini){ obj1 = {};  }
      let url = data.data.data;
      if(pay_info==1){
        obj1 = {code: data.data.extral.code, index: 1 }; //公众号发起支付
        url = getServer().admin +  'wap/getOrderInfo.action'
      }

      axios.post( url, Qs.stringify(obj1), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      }).then(function (data) {
        self.$loading.hide();
        let param = data.data.data;
        if(param == 0){
          self.$toast('支付成功')
          if(callback) callback(true)
          return
        }else if (!param) {
          self.$toast("支付错误");
          return
        }else {
          //判断是否是在微信小程序环境
          param = JSON.parse(param)
          if(pay_info==1){
            self.orderCode = obj1.code
            handleWxpay1(self,param,callback,obj1.code)
          }else {
            handleWxpay(self,param,callback)
          }

        }
      })
    }else {
      self.$loading.hide();
      self.$toast(data.data.errmsg);

      setTimeout(function(){
        if (data.data.errmsg == '已经购买') {
          if(callback) callback(true)
        }
      },500)
    }

  }).catch(function (data){
    self.$loading.hide();
    self.$toast(data.data.errmsg);

    setTimeout(function(){
      if (data.data.errmsg == '已经购买') {
        if(callback) callback(true)
      }
    },500)
  })

};

/**
 * 创建订单（支付宝）
 * @param self    指向this
 * @param pid    专辑id
 * @param price   专辑价格
 * @param cid   优惠券id
 * @param callback   回调函数
 */
export const creatZfbOrder = (self, pid, price, cid, callback) => {
  self.$loading.show('提交订单中');

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let qid =  getStore("qid") || "";
  if(qid){
    qid = qid.qid
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }

  let userInfo = getStore("userInfo");
  let source =  getStore("source") || "";
  let openidMini = getStore("openidMini");
  let obj = {
    openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
    pid: pid,
    totalmoney: price,
    cid: cid || '',
    qid: qid,
    spotid: spotid,
    sourceBtn: source.source || ''
  };

  let payInfo = getStore("payInfo");
  let pay_info = (payInfo && payInfo.pay_info) || "";
  if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
    obj.index = 1;
  }
  axios.post( getServer().admin + "alipay/v2/createorder.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if (data.data.errcode == "00000") {

      let obj1 = { index: 1 }; //公众号发起支付
      if(isWxMini){ obj1 = {}; }
      let url = `${data.data.data}&url=${encodeURIComponent('https://jpjs.geeker.com.cn/dist/dist/dist/dist/index.html#/pay-success')}`
      // let url = data.data.data;
      if(pay_info==1){
        obj1 = {code: data.data.extral.code, index: 1 }; //公众号发起支付
        url = getServer().admin +  'wap/getOrderInfo.action'
      }
      url = url.replace(/"/g, "");
      axios.post( url, Qs.stringify(obj1), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      }).then(function (data) {
        self.$loading.hide();
        setStore('payUrl', {url: window.location.href}, 1)
        setStore('form', {data: data.data.data}, 1)
        window.location.href = 'https://jpjs.geeker.com.cn/dist/dist/dist/dist/index.html#/pay-transfer'
        // const div = document.createElement('div');
        // div.innerHTML = data.data.data;
        // document.body.appendChild(div);
        // document.forms[0].submit();
      }).catch(err => {
        alert(JSON.stringify(err))
      })
    }else {
      self.$loading.hide();
      self.$toast(data.data.errmsg);

      setTimeout(function(){
        if (data.data.errmsg == '已经购买') {
          if(callback) callback(true)
        }
      },500)
    }

  }).catch(function (data){
    self.$loading.hide();
    self.$toast(data.data.errmsg);

    setTimeout(function(){
      if (data.data.errmsg == '已经购买') {
        if(callback) callback(true)
      }
    },500)
  })

};

/**
 * 创建订单（微信）(购买会员)
 * @param self    指向this
 * @param pid    购买的会员id
 * @param price   购买的会员当前的价格
 * @param cid   优惠券id
 * @param callback   回调函数
 */
export const creatWxOrderMeb = (self, pid, price, cid, callback) => {
  self.$loading.show('提交订单中');

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let qid =  getStore("qid") || "";
  if(qid){
    qid = qid.qid
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }

  let userInfo = getStore("userInfo");
  let source =  getStore("source") || "";
  let openidMini = getStore("openidMini");
  let obj = {
    openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
    pid: pid,
    totalmoney: price,
    cid: cid || '',
    qid: qid,
    spotid: spotid,
    sourceBtn: source.source || ''
  };
  let payInfo = getStore("payInfo");
  let pay_info = (payInfo && payInfo.pay_info) || "";
  if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
    obj.index = 1;
  }

  axios.post( getServer().admin + "createorderH.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if(data.data.errcode == "00000"){

      let obj1 = { index: 1 }; //公众号发起支付
      if(isWxMini){ obj1 = {};  }
      let url = data.data.data;
      if(pay_info==1){
        obj1 = {code: data.data.extral.code, index: 1 }; //公众号发起支付
        url = getServer().admin +  'wap/getOrderInfo.action'
      }

      axios.post( url, Qs.stringify(obj1), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      }).then(function (data) {
        self.$loading.hide();
        let param = data.data.data;
        if(param == 0){
          self.$toast('支付成功')
          if(callback) callback(true)
          return
        }else if (!param) {
          self.$toast("支付错误");
          return
        }else {
          //判断是否是在微信小程序环境
          param = JSON.parse(param)
          if(pay_info==1){
            self.orderCode = obj1.code
            handleWxpay1(self,param,callback,obj1.code)
          }else {
            handleWxpay(self,param,callback)
          }
        }
      })
    }else {
      self.$loading.hide();
      self.$toast(data.data.errmsg);

      setTimeout(function(){
        if (data.data.errmsg == '已经购买') {
          if(callback) callback(true)
        }
      },500)
    }

  }).catch(function (data){
    self.$loading.hide();
    self.$toast(data.data.errmsg);

    setTimeout(function(){
      if (data.data.errmsg == '已经购买') {
        if(callback) callback(true)
      }
    },500)
  })

};

/**
 * 创建订单（支付宝）(购买会员)
 * @param self    指向this
 * @param pid    购买的会员id
 * @param price   购买的会员当前的价格
 * @param cid   优惠券id
 * @param callback   回调函数
 */
export const creatZfbOrderMeb = (self, pid, price, cid, callback) => {
  self.$loading.show('提交订单中');

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let qid =  getStore("qid") || "";
  if(qid){
    qid = qid.qid
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }

  let userInfo = getStore("userInfo");
  let source =  getStore("source") || "";
  let openidMini = getStore("openidMini");
  let obj = {
    openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
    pid: pid,
    totalmoney: price,
    cid: cid || '',
    qid: qid,
    spotid: spotid,
    sourceBtn: source.source || ''
  };
  let payInfo = getStore("payInfo");
  let pay_info = (payInfo && payInfo.pay_info) || "";
  if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
    obj.index = 1;
  }

  axios.post( getServer().admin + "alipay/v2/createorderH.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if(data.data.errcode == "00000"){

      let obj1 = { index: 1 }; //公众号发起支付
      if(isWxMini){ obj1 = {};  }
      let url = `${data.data.data}&url=${encodeURIComponent('https://jpjs.geeker.com.cn/dist/dist/dist/dist/index.html#/pay-success')}`
      if(pay_info==1){
        obj1 = {code: data.data.extral.code, index: 1 }; //公众号发起支付
        url = getServer().admin +  'wap/getOrderInfo.action'
      }

      axios.post( url, Qs.stringify(obj1), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      }).then(function (data) {
        self.$loading.hide();
        setStore('payUrl', {url: window.location.href}, 1)
        setStore('form', {data: data.data.data}, 1)
        window.location.href = 'https://jpjs.geeker.com.cn/dist/dist/dist/dist/index.html#/pay-transfer'
        // window.location.replace('https://jpjs.geeker.com.cn/dist/dist/dist/dist/index.html#/pay-transfer')
        // self.$loading.hide();
        // setStore('payUrl', window.location.href)
        // const div = document.createElement('div');
        // div.innerHTML = data.data.data;
        // document.body.appendChild(div);
        // document.forms[0].submit();
        if(callback) callback(true)
      })
    }else {
      self.$loading.hide();
      self.$toast(data.data.errmsg);

      setTimeout(function(){
        if (data.data.errmsg == '已经购买') {
          if(callback) callback(true)
        }
      },500)
    }

  }).catch(function (data){
    self.$loading.hide();
    self.$toast(data.data.errmsg);

    setTimeout(function(){
      if (data.data.errmsg == '已经购买') {
        if(callback) callback(true)
      }
    },500)
  })

};

/**
 * 创建订单（一网通）
 * @param self    指向this
 * @param pid    专辑id
 * @param price   专辑价格
 * @param cid   优惠券id
 * @param callback   回调函数
 */
export const creatYOrder = (self, pid, price, cid, callback) => {

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let qid =  getStore("qid") || "";
  if(qid){
    qid = qid.qid
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }
  //post('http://wctest.xcy.geeker.com.cn/snPc/aaa1.html','a');

  self.$loading.show('提交订单中');
  let userInfo = getStore("userInfo");
  let source =  getStore("source") || "";
  let obj = {
    openid: userInfo.openid,
    pid: pid,
    totalmoney: price,
    cid: cid || '',
    qid: qid,
    spotid: spotid,
    sourceBtn: source.source || ''
  };
  axios.post( getServer().admin + "ywtpay/preCreate.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if(data.data.errcode == "00000"){

      let obj1 = { ordernum: data.data.extral.ordernum }; //公众号发起支付
      axios.post( getServer().admin + data.data.data, Qs.stringify(obj1), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      }).then(function (data) {
        self.$loading.hide();

        if(data.data.errcode == "00000"){
          var param = JSON.stringify(data.data.data);
          post('https://netpay.cmbchina.com/netpayment/BaseHttp.dll?MB_EUserPay',param);
        }else {
          self.$toast("支付错误");
          return
        }
      })
    }else {

      self.$loading.hide();
      self.$toast(data.data.errmsg);

      setTimeout(function(){
        if (data.data.errmsg == '已经购买') {
          if(callback) callback(true)
        }
      },500)
    }

  }).catch(function (data){
    self.$loading.hide();
    self.$toast(data.data.errmsg);

    setTimeout(function(){
      if (data.data.errmsg == '已经购买') {
        if(callback) callback(true)
      }
    },500)
  })

};

/**
 * 创建订单（一网通）(购买会员)
 * @param self    指向this
 * @param bagid    专辑id
 * @param pid    购买的会员id
 * @param price   购买的会员当前的价格
 * @param cid   优惠券id
 * @param callback   回调函数
 */
export const creatYOrderMeb = (self, bagid, pid, price, cid, callback) => {

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let qid =  getStore("qid") || "";
  if(qid){
    qid = qid.qid
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }
  //post('http://wctest.xcy.geeker.com.cn/snPc/aaa1.html','a');

  self.$loading.show('提交订单中');
  let userInfo = getStore("userInfo");
  let source =  getStore("source") || "";
  let obj = {
    openid: userInfo.openid,
    bagid: bagid,
    pid: pid,
    totalmoney: price,
    cid: cid || '',
    qid: qid,
    spotid: spotid,
    sourceBtn: source.source || ''
  };
  axios.post( getServer().admin + "ywtpay/preCreateH.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if(data.data.errcode == "00000"){

      let obj1 = { ordernum: data.data.extral.ordernum }; //公众号发起支付
      axios.post( getServer().admin + data.data.data, Qs.stringify(obj1), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      }).then(function (data) {
        self.$loading.hide();

        if(data.data.errcode == "00000"){
          var param = JSON.stringify(data.data.data);
          post('https://netpay.cmbchina.com/netpayment/BaseHttp.dll?MB_EUserPay',param);
        }else {
          self.$toast("支付错误");
          return
        }
      })
    }else {

      self.$loading.hide();
      self.$toast(data.data.errmsg);

      setTimeout(function(){
        if (data.data.errmsg == '已经购买') {
          if(callback) callback(true)
        }
      },500)
    }

  }).catch(function (data){
    self.$loading.hide();
    self.$toast(data.data.errmsg);

    setTimeout(function(){
      if (data.data.errmsg == '已经购买') {
        if(callback) callback(true)
      }
    },500)
  })

};

/**
 * 创建表单提交
 * @param path    提交的地址
 * @param params   提交的参数
 */
export const post = (path, params) => {
  var method = "post";
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  var hiddenField = document.createElement("input");
  hiddenField.setAttribute("type", "hidden");
  hiddenField.setAttribute("name", "jsonRequestData");
  hiddenField.setAttribute("value", params);

  form.appendChild(hiddenField);

  document.body.appendChild(form);
  form.submit();
};



/**
 * 获取钱包余额
 * @param id    渠道人员id
 * @param callback    回调函数
 */
export const getMoney = (id, callback) =>{
  let obj = {
    id: id
  };
  axios.post( getServer().admin + "authChannel/getChannelData.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data.data);
  })
};


/**
 * 微信提现到钱包
 */
export const wxTX = (obj, callback) =>{
  axios.post( getServer().admin + "wxTX.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data.data);
  })
};


/**
 * 推广赚钱：top榜单
 * @param id
 * @param callback    回调函数
 */
export const getTop = (id, callback) =>{
  let obj = {
    id: id
  };
  axios.post( getServer().admin + "authChannel/top.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data.data);
  })
};

/**
 * 推广赚钱：我的收入明细
 * @param obj
 * @param callback    回调函数
 */
export const getMyincome = (obj, callback) =>{

  axios.post( getServer().admin + "authChannel/inComeRecord.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data.data);
  })
};

/**
 * 推广赚钱：我的提现记录
 * @param obj
 * @param callback    回调函数
 */
export const getMyrecord = (obj, callback) =>{

  axios.post( getServer().admin + "authChannel/txRecord.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(function (data) {
    if(callback) callback(data.data);
  })
};


/**
 * 播放音频点击事件(地图页面)
 * @param self    指向this
 * @param index  点击试听当前所在语音列表voicelist下标
 */
export const playVideo = (self,index) =>{
  self.global.Audio1 = document.getElementById('Audio1');

  if (self.currIndex == index) {

    if (self.global.Audio1.paused) {
      self.global.Audio1.play();
      self.isplay = 1;
      TimeVideo(self,self.voicelist[index].totaltime);
      self.global.set_playing(true)
      self.global.set_playerShow(true)
    } else {
      self.global.Audio1.pause();
      self.$loading.hide();
      self.isplay = 0;
      if(self.global.videoTimer != null){
        clearInterval(self.global.videoTimer);
      }
      self.global.set_playing(false)
      self.global.set_playerShow(false)
    }

  } else {
    self.isplay = 1;
    self.currTime = 0;
    self.index1 = index;

    self.spotid = self.voicelist[index].spotid;

    let appKey =  getStore("appKey") || "";
    if(appKey){
      appKey = appKey.appKey
    }

    setTimeout(function(){
      self.currIndex = index;
      self.global.Audio1.src = self.voicelist[index].url;
      self.global.Audio1.preload = "auto";
      self.global.Audio1.play();
      if(self.global.Audio1.readyState != 4){
        self.$loading.show('音频加载中');
      }
      self.isplay = 1;
      TimeVideo(self,self.voicelist[index].totaltime);


      //记录收听历史接口
      let obj = {
        openid: self.userInfo.openid,
        vid: self.voicelist[index].id
      };
      axios.post( getServer().admin + "uploadHotLevel.do", Qs.stringify(obj), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      });

      self.global.set_currBag(self.currGuide)
      self.global.set_playing(true)
      self.global.set_playerShow(true)
      self.global.set_playList(self.voicelist)
      self.global.set_currVoice(self.voicelist[index])
      self.global.set_currIndex(index)
      self.global.set_currUrl(self.voicelist[index].url)

    },100)
  }
};


/**
 * 实时监听音频播放进度，播放结束继续播放下一段音频(地图页面)
 * @param self    指向this
 * @param totalTime  当前音频的总时长
 */
export const playVideoTime = (self,totalTime) =>{
  //if(self.playTimer != null){
  //  clearInterval(self.playTimer);
  //}
  if(self.global.videoTimer != null){
    clearInterval(self.global.videoTimer);
  }
  self.playTimer = setInterval(function () {
    if (self.Audio.currentTime > 0) {
      self.$loading.hide();
    }
    self.playSlider = document.getElementById('playSlider');
    if (self.Audio.currentTime != undefined && !isNaN(self.Audio.currentTime)) {
      self.currTime = (totalTime - self.Audio.currentTime);
      if(self.buy == true){
        self.currSlider = (self.Audio.currentTime / totalTime) * self.playSlider.offsetWidth + "px";
      }
    }

  }, 1000);

  self.global.Audio1.onended = function() {  //音频播放结束
    if(self.$route.path=='/map'||self.$route.path=='/map-tour'){
      let currIndex = (self.currIndex == self.voicelist.length -1) ? 0 : (parseInt(self.currIndex) + 1);
      if(self.buy == true || currIndex< 2){
        playVideo(self,currIndex);

        var ind = self.getIndex(self.spotlist,self.voicelist[currIndex].spotid,2);
        self.spotClick(ind);
      }else {
        self.currIndex = -1;
        //self.Audio.pause();
        if(!self.global.Audio1.paused) self.global.Audio1.pause();
        self.isplay = 0;
        self.$toast('试听结束，请购买该张专辑');
        //clearInterval(self.playTimer);
        if(self.global.videoTimer != null){
          clearInterval(self.global.videoTimer);
        }
        self.global.set_playing(false)
        self.global.set_playerShow(false)
      }
    }
  };

};

/**
 * 拖动播放进度按钮(地图页面)
 * @param self    指向this
 */
export const playDragSlide = (self) => {
  //if(self.playTimer != null){
  //  clearInterval(self.playTimer);
  //}
  if(self.global.videoTimer != null){
    clearInterval(self.global.videoTimer);
  }
  this.minDiv = document.getElementsByClassName("speedDot")[0]; //小方块
  this.width = parseInt(this.minDiv.offsetWidth); //小方块的宽度

  this.lineDiv = this.minDiv.parentNode; //背景长线条

  var that = this;
  var percent = 0;

  var move = function(e) {
    var x = e.touches[0].pageX;

    var lineDiv_left = that.getPosition(that.lineDiv).left; //长线条的横坐标
    var minDiv_left = x - lineDiv_left; //小方块相对于父元素（长线条）的left值
    if (minDiv_left < 0) {
      minDiv_left = 0;
    }

    //拖动指数
    percent = (minDiv_left / that.lineDiv.offsetWidth).toFixed(2);
    percent = percent > 1 ? 1 : percent;

    that.minDiv.style.left = percent*100 + "%";
    self.currSlider = percent*100 + "%";
  };

  var end = function() {
    self.currIndex = self.index1;

    //if(self.voicelist[self.index1].url!=self.Audio.src){
    //  self.Audio.src = self.voicelist[self.index1].url
    //  self.spotid = self.voicelist[self.index1].spotid;
    //}

    if(self.voicelist[self.index1].url!=self.global.Audio1.src){
      self.global.Audio1 = self.voicelist[self.index1].url
      self.spotid = self.voicelist[self.index1].spotid;

      self.global.set_currBag(self.currGuide)
      self.global.set_playList(self.voicelist)
      self.global.set_currVoice(self.voicelist[self.index1])
      self.global.set_currIndex(self.index1)
      self.global.set_currUrl(self.voicelist[self.index1].url)
    }


    //self.currTime = (self.voicelist[self.index1].totaltime)*percent;
    //self.isplay = 1;
    //self.Audio.play();
    //if(self.Audio.readyState == "4"){
    //  self.Audio.currentTime = self.currTime;
    //}else {
    //  self.currTime = 0;
    //  self.$loading.show('当前进度尚在缓冲中');
    //}
    //self.Audio.play();
    //playVideoTime(self,self.voicelist[self.index1].totaltime);


    self.currTime = (self.voicelist[self.index1].totaltime)*percent;
    self.isplay = 1;
    self.global.Audio1.play();
    if(self.global.Audio1.readyState == "4"){
      self.global.Audio1.currentTime = self.currTime;
    }else {
      self.currTime = 0;
      self.$loading.show('当前进度尚在缓冲中');
    }
    self.global.Audio1.play();
    self.global.set_playing(true)
    self.global.set_playerShow(true)

    TimeVideo(self,self.voicelist[self.index1].totaltime);

  };

  //获取元素的绝对位置,工具函数
  this.getPosition = function(node) {
    var left = node.offsetLeft; //获取元素相对于其父元素的left值var left
    var top = node.offsetTop;
    var current = node.offsetParent; // 取得元素的offsetParent
    // 一直循环直到根元素

    while (current != null) {
      left += current.offsetLeft;
      top += current.offsetTop;
      current = current.offsetParent;
    }
    return {
      "left": left,
      "top": top
    };
  };
  this.minDiv.addEventListener("touchmove", move);
  this.minDiv.addEventListener("touchend", end);
};

/**
 * 记录收听历史接口
 */
export const playRecord = (bagid) => {
  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let userInfo = getStore("userInfo");
  let obj = {
    openid: userInfo.openid,
    vid: bagid
  };
  axios.post( getServer().admin + "uploadHotLevel.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  });
};

/**
 * 下载音频
 * @param bid    专辑id
 */
export const downVoice = (bagid, fun1, fun2) =>{
  axios.post( getServer().admin + "voiceBagList/download.do", Qs.stringify({bagid: bagid}), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    onDownloadProgress (res){
      if(fun1) fun1(res);
    }
  }).then(function (data) {
    if(fun2) fun2(data.data);
  })

};

/**
 * 记录文章页面分享次数
 */
export const artRecord = (bagid) => {
  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let userInfo = getStore("userInfo");
  let obj = {
    bagid: bagid
  };
  axios.post( getServer().admin + "bagShare.do", Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  });
};


/**
 * 创建订单（微信）——购买多张专辑  /  购买单个语音
 * @param self    指向this
 * @param pid    专辑id
 * @param price   专辑价格
 * @param cid   优惠券id
 * @param callback   回调函数
 */
export const mulCreateOrder = (self, ids, bundleid, callback) => {
  self.$loading.show('提交订单中');

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }
  let userInfo = getStore("userInfo");
  let source =  getStore("source") || "";
  let openidMini = getStore("openidMini");

  var url = 'bundle/mulcreateorder.do';
  let obj = {
    openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
    ids: ids,
    bundleid: bundleid,
    spotid: spotid,
    sourceBtn: source.source || ''
  };

  if(bundleid=='order'){
    url = 'spotbuy/order.do';
    obj = {
      openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
      ids: ids,
      pid: self.pid,
      totalmoney: self.totalPrice,
      spotid: spotid,
      sourceBtn: source.source || ''
    };
  }else if(bundleid=='createorder'){
    url = 'spotbuy/createorder.do';
    obj = {
      openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
      pid: self.pid,
      totalmoney: self.totalPrice,
      spotid: spotid,
      sourceBtn: source.source || ''
    };
  }
  let payInfo = getStore("payInfo");
  let pay_info = (payInfo && payInfo.pay_info) || "";
  if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
    obj.index = 1;
  }

  axios.post( getServer().admin + url, Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if(data.data.errcode == "00000"){
      let obj1 = { index: 1 }; //公众号发起支付
      if(isWxMini){ obj1 = {};  }
      let url1 = data.data.data;
      if(pay_info==1){
        obj1 = {code: data.data.extral.code, index: 1 }; //公众号发起支付
        url1 = getServer().admin +  'wap/getOrderInfo.action'
      }

      axios.post( url1, Qs.stringify(obj1), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      }).then(function (data) {
        self.$loading.hide();
        let param = data.data.data;
        if(param == 0){
          self.$toast('支付成功')
          if(callback) callback(true)
          return
        }else if (!param) {
          self.$toast("支付错误");
          return
        }else {
          //判断是否是在微信小程序环境
          param = JSON.parse(param)
          if(pay_info==1){
            self.orderCode = obj1.code
            handleWxpay1(self,param,callback,obj1.code)
          }else {
            handleWxpay(self,param,callback)
          }
        }
      })
    }else {
      self.$loading.hide();
      self.$toast(data.data.errmsg);

      setTimeout(function(){
        if (data.data.errmsg == '已经购买') {
          if(callback) callback(true)
        }
      },500)
    }

  }).catch(function (data){
    self.$loading.hide();
    self.$toast(data.data.errmsg);

    setTimeout(function(){
      if (data.data.errmsg == '已经购买') {
        if(callback) callback(true)
      }
    },500)
  })

};

/**
 * 创建订单（支付宝）——购买多张专辑  /  购买单个语音
 * @param self    指向this
 * @param pid    专辑id
 * @param price   专辑价格
 * @param cid   优惠券id
 * @param callback   回调函数
 */
export const mulZfbCreateOrder = (self, ids, bundleid, callback) => {
  self.$loading.show('提交订单中');

  let appKey =  getStore("appKey") || "";
  if(appKey){
    appKey = appKey.appKey
  }
  let spotid =  getStore("spotid") || "";
  if(spotid){
    spotid = spotid.spotid
  }
  let userInfo = getStore("userInfo");
  let source =  getStore("source") || "";
  let openidMini = getStore("openidMini");

  var url = 'alipay/v2/mulcreateorder.do';
  let obj = {
    openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
    ids: ids,
    bundleid: bundleid,
    spotid: spotid,
    sourceBtn: source.source || ''
  };

  if(bundleid=='order'){
    url = 'alipay/v2/spotbuy/order.do';
    obj = {
      openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
      ids: ids,
      pid: self.pid,
      totalmoney: self.totalPrice,
      spotid: spotid,
      sourceBtn: source.source || ''
    };
  }else if(bundleid=='createorder'){
    url = 'alipay/v2/spotbuy/createorder.do';
    obj = {
      openid: (isWxMini ? (openidMini && openidMini.openid) : userInfo.openid),
      pid: self.pid,
      totalmoney: self.totalPrice,
      spotid: spotid,
      sourceBtn: source.source || ''
    };
  }
  let payInfo = getStore("payInfo");
  let pay_info = (payInfo && payInfo.pay_info) || "";
  if(pay_info==1){//pay_info :  1 (h支付) 其他值维持原样
    obj.index = 1;
  }

  axios.post( getServer().admin + url, Qs.stringify(obj), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'appKey': appKey
    }
  }).then(function (data) {
    if(data.data.errcode == "00000"){
      let obj1 = { index: 1 }; //公众号发起支付
      if(isWxMini){ obj1 = {};  }
      let url1 = `${data.data.data}&url=${encodeURIComponent('https://jpjs.geeker.com.cn/dist/dist/dist/dist/index.html#/pay-success')}`
      if(pay_info==1){
        obj1 = {code: data.data.extral.code, index: 1 }; //公众号发起支付
        url1 = getServer().admin +  'wap/getOrderInfo.action'
      }

      axios.post( url1, Qs.stringify(obj1), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'appKey': appKey
        }
      }).then(function (data) {
        self.$loading.hide();
        setStore('payUrl', {url: window.location.href}, 1)
        setStore('form', {data: data.data.data}, 1)
        window.location.href = 'https://jpjs.geeker.com.cn/dist/dist/dist/dist/index.html#/pay-transfer'
        // const div = document.createElement('div');
        // div.innerHTML = data.data.data;  //res.data是返回的表单
        // document.body.appendChild(div);
        // document.forms[0].submit();
      })
    }else {
      self.$loading.hide();
      self.$toast(data.data.errmsg);

      setTimeout(function(){
        if (data.data.errmsg == '已经购买') {
          if(callback) callback(true)
        }
      },500)
    }

  }).catch(function (data){
    self.$loading.hide();
    self.$toast(data.data.errmsg);

    setTimeout(function(){
      if (data.data.errmsg == '已经购买') {
        if(callback) callback(true)
      }
    },500)
  })

};

//小程序环境支付
const wxMiniPay = (param) => {
  // {"appId":"wx844697a27148c8ff","nonceStr":"5de54f7deab724e95015ee8f7c5c1fb7","package":"prepay_id=wx151018307620167c056d9f65243a470000","paySign":"8D40068EF4FD0AF362321CE36C349BB2","signType":"MD5","timeStamp":"1660529910"}
  var option = '?timeStamp='+ param.timeStamp +'&nonceStr='+ param.nonceStr +'&package'+ param.package +'&signType='+ param.signType
    +'&paySign='+ param.paySign;

  var url = encodeURIComponent(location.href);

  var path = '/pages/web/pay'+ option + '&q=' + url;
  wx.miniProgram.navigateTo({url: path});
};


//解析srt字幕文件
export const getSrtTxt = (url,callback) => {
  let obj = {};
  axios.get(url, Qs.stringify(obj), { }).then(function (data) {
    if(callback) callback(data.data);
  })
};





// WEBPACK FOOTER //
// ./src/utils/wechat.js